import React from 'react'
import StudentsList from '../../features/trainer/StudentsList'
const TrainerStudentsListPage = () => {
  return <StudentsList/>
}

export default TrainerStudentsListPage